import React from 'react';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/src/formatters';

import { messages } from './messages';
import { $WarrantyTypeContainer,$IgnoreDateRulesChecking } from './WarrantyType.styles';

interface WarrantyTypeProps {
  name: string;
  ignoreDateRulesChecking?: boolean;
}

export const WarrantyType: React.FC<WarrantyTypeProps> = ({
  name,
  ignoreDateRulesChecking,
}) => {
  return (
    <$WarrantyTypeContainer >
      <span>{name}</span>
      {ignoreDateRulesChecking && (
        <>
          <span>-</span>
          <$IgnoreDateRulesChecking>
            <SafeFormattedMessageWithoutSpread message={messages.ignoreDateRulesChecking} />
          </$IgnoreDateRulesChecking>
        </>
      )}
    </$WarrantyTypeContainer>
  );
};

WarrantyType.displayName = 'WarrantyType';

